import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import validator from 'validator';
import { Trans, t } from '@lingui/macro';
import { I18n } from '@lingui/react';
import i18nInstance from '@moka-bo/i18n';
import styles from './style.css';
import Captcha from './Captcha';

const isPhoneNumberValid = phoneNumber => {
  return (
    phoneNumber.length >= 10 &&
    phoneNumber.length <= 15 &&
    (phoneNumber.substr(0, 3) === '+62' || phoneNumber.substr(0, 1) === '0')
  );
};

const validate = values => {
  const { email } = values;
  const errors = {};
  if (!email) {
    errors.email = i18nInstance._(
      t`The email address or phone number is required`
    );
  } else if (isNaN(email) && !validator.isEmail(email)) {
    errors.email = i18nInstance._(t`Enter a valid email address`);
  } else if (!isNaN(email) && !isPhoneNumberValid(email)) {
    errors.email = i18nInstance._(t`Enter a valid phone number`);
  }
  if (!values.captcha) {
    errors.captcha = i18nInstance._(t`The captcha is not valid`);
  }
  return errors;
};

const inputField = field => (
  <div>
    <I18n>
      {({ i18n }) => (
        <input
          {...field.input}
          type="text"
          maxLength={field.maxLength}
          className={`form-control ${
            field.meta.touched && field.meta.error ? styles['input-error'] : ''
          }`}
          placeholder={i18n._(t`Email or phone number`)}
        />
      )}
    </I18n>
    <small className="error">
      {field.meta.touched ? field.meta.error : ''}
    </small>
  </div>
);

let ForgotPasswordForm = class forgotPasswordForm extends React.Component {
  render() {
    const { handleSubmit, valid } = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <Field
          component={inputField}
          name="email"
          maxLength="40"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
        />
        <br />
        <div
          className={`row section-captcha ${styles['margin-bottom-20']} ${
            styles['align-left-normal']
          }`}
        >
          <div className="col-xs-12 col-sm-12">
            <center className={`${styles['margin-bottom-30']}`}>
              <Field component={Captcha} name="captcha" />
            </center>
          </div>
        </div>
        <button
          type="submit"
          className="btn btn-primary btn-block"
          disabled={!valid}
        >
          <Trans>Find account</Trans>
        </button>
      </form>
    );
  }
};

ForgotPasswordForm.propTypes = {
  data: PropTypes.object,
  dispatch: PropTypes.func,
  onSubmit: PropTypes.func,
  error: PropTypes.object,
  currentlySending: PropTypes.bool,
};

ForgotPasswordForm = reduxForm({
  form: 'forgotPasswordForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
})(ForgotPasswordForm);

export default ForgotPasswordForm;
